import GenericResultView from '@containers/generic_result';
import type { FC } from 'react';

const DocumentSubmissionCompletePage: FC = () => <GenericResultView isKycSubmitted isSuccess />;

export default DocumentSubmissionCompletePage;
